
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.95411 4.63659L2.28746 0.886601C2.15829 0.814101 2.00079 0.815768 1.87329 0.889934C1.74496 0.964934 1.66663 1.1016 1.66663 1.24993V8.74992C1.66663 8.89825 1.74496 9.03492 1.87329 9.10992C1.93829 9.14742 2.01079 9.16659 2.08329 9.16659C2.15329 9.16659 2.22412 9.14909 2.28746 9.11325L8.95411 5.36326C9.08494 5.28909 9.16661 5.15076 9.16661 4.99993C9.16661 4.84909 9.08494 4.71076 8.95411 4.63659Z"}})])
          )
        }
      }
    